// PHCDashboardConstants.js

export const PHCDashboardConstants = {
  FETCH_PORTFOLIO_LIST_API: "phc/portfolio/list",
  FETCH_PORTFOLIO_REQUEST: "FETCH_PORTFOLIO_REQUEST",
  FETCH_PORTFOLIO_SUCCESS: "FETCH_PORTFOLIO_SUCCESS",
  FETCH_PORTFOLIO_FAILURE: "FETCH_PORTFOLIO_FAILURE",
  ADD_PORTFOLIO: "ADD_PORTFOLIO",

  PHC_CROSS_SELL_API: "phc/portfolio/phc-cross-sell",

  SET_COMPLETED_PORTFOLIO: "SET_COMPLETED_PORTFOLIO",
  PHC_PORTFOLIO_DELETE_API: "phc/portfolio/deletePortfolio",
  UPDATE_PORTFOLIO: "UPDATE_PORTFOLIO",

  SET_TAGS: "SET_TAGS",
  SET_ACTIVE_PORTFOLIO: "SET_ACTIVE_PORTFOLIO",
  SET_CURRENT_VIEW: "SET_CURRENT_VIEW",
  SET_JUST_UPLOADED_PORTFOLIO: "SET_JUST_UPLOADED_PORTFOLIO",
  ADD_NON_EXISTENT_PORTFOLIO: "ADD_NON_EXISTENT_PORTFOLIO",
  SET_FROM_ONE_MONEY: "SET_FROM_ONE_MONEY",
  RESET_DASHBOARD_FLOW: "RESET_DASHBOARD_FLOW",
};
